<template>
  <div v-on:click.capture="hsetQuery">
    <section v-for="(item, index) in routes" :key="item.id">
      <h-menu-item v-if="!item.hidden && !item.children" :name="item.id" :idx="index">
        <template>
          <h-icon :name="item.icon || 'computer'"></h-icon>
          <span class="li-span">{{item.title}}</span>
        </template>
      </h-menu-item>
      <h-menu-item v-else-if="!item.hidden && item.children && item.children.length == 0" :name="item.id" :idx="index">
        <template>
          <h-icon :name="item.icon || 'computer'"></h-icon>
          <span class="li-span">{{item.title}}</span>
        </template>
      </h-menu-item>
      <h-submenu v-else-if="!item.hidden && item.children.length > 0" :name="item.id" :idx="index">
        <template slot="title">
          <h-icon :name="item.icon || 'computer'"></h-icon>
          <span class="li-span">{{item.title}}</span>
        </template>
        <div v-for="(child, i) in item.children" :key="child.id">
          <div v-if="!child.hidden">
            <sidebar-item v-if="child.children && child.children.length > 0" :routes="[child]"></sidebar-item>
            <h-menu-item v-else :name="child.id" :idx="i">
              <h-icon :name="child.icon || 'computer'"></h-icon>
              <span class="li-span">{{child.title}}</span>
            </h-menu-item>
          </div>
        </div>
      </h-submenu>
    </section>
  </div>
</template>
<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
    }
  },
  watch: {
    routes (n, o) {
      //console.log('n:', n)
    }
  },
  mounted () {
    //console.log(this.routes)
  },
  methods: {
    hsetQuery () {
      this.$emit('expandSelection', '')
    }
  }
}
</script>
<style lang="scss" scoped>
.lightblue .h-menu-vertical {
  .h-menu-item {
    padding: 4px 16px;
    i {
      font-size: 14px;
    }
  }
  .h-menu-submenu-title {
    .iconfont {
      font-size: 14px;
    }
  }
}
</style>
